// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"FooterDisclaimer_disclaimer__esiTQ"};